// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

// Image
import lock from "assets/images/illustrations/lock.png";
import { useState } from "react";
import { AuthService } from "services/authService";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Link } from "react-router-dom";
import SoftTypography from "components/SoftTypography";

const regexEmail =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function ForgotPassword() {
  const [err, setErr] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!email) {
      setErr("Vui lòng nhập email !");
      setTimeout(() => {
        setErr("");
      }, 3000);
      return;
    }
    if (!regexEmail.test(email)) {
      setErr("Email không hợp lệ");
      setTimeout(() => {
        setErr("");
      }, 3000);
      return;
    }

    try {
      setLoading(true);
      await AuthService.forgotPassword(email);
      setOpen(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      console.error({ error });
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEmail("");
  };

  return (
    <IllustrationLayout
      title="Quên mật khẩu"
      description={
        err ? <p style={{ color: "red" }}>{err}</p> : "Nhập email của bạn để nhận mật khẩu mới"
      }
      illustration={{
        image: lock,
        title: '"Hưng Thịnh Dashboard"',
        description:
          "The more effortless the writing looks, the more effort the writer actually put into the process.",
      }}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={1}>
          <SoftInput
            type="email"
            placeholder="Email"
            size="large"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </SoftBox>
        <Link to="/dashboards/sign-in">
          <SoftTypography
            variant="button"
            fontWeight="regular"
            sx={{ cursor: "pointer", userSelect: "none", color: "#67748e" }}
          >
            Đăng nhập ?
          </SoftTypography>
        </Link>
        <SoftBox mt={1} mb={1}>
          <SoftButton onClick={handleSubmit} variant="gradient" color="info" size="large" fullWidth>
            {loading ? "Đang gửi..." : "Gửi"}
          </SoftButton>
        </SoftBox>
      </SoftBox>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Gửi mật khẩu thành công</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Mật khẩu đã được gửi đến email <strong>{email}</strong>
            <br />
            Vui lòng kiểm tra email !
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Đồng ý
          </Button>
        </DialogActions>
      </Dialog>
    </IllustrationLayout>
  );
}

export default ForgotPassword;
